import { render, staticRenderFns } from "./ShareTree.vue?vue&type=template&id=036eb046&scoped=true"
import script from "./ShareTree.vue?vue&type=script&lang=js"
export * from "./ShareTree.vue?vue&type=script&lang=js"
import style0 from "./ShareTree.vue?vue&type=style&index=0&id=036eb046&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036eb046",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('036eb046')) {
      api.createRecord('036eb046', component.options)
    } else {
      api.reload('036eb046', component.options)
    }
    module.hot.accept("./ShareTree.vue?vue&type=template&id=036eb046&scoped=true", function () {
      api.rerender('036eb046', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/panel/grantAuth/ShareTree.vue"
export default component.exports